import { client } from './client'

const getPrepaymentsService = async (cocap: string) => {
  const { data } = await client.get('/person/prepayments', {
    headers: {
      cocap
    }
  })
  return data
}

const postInvoiceFileService = async (cocap: string, formData: FormData, invoiceId: string) => {
  const { data } = await client.post(`/invoices/file?invoice=${invoiceId}`, formData, {
    headers: {
      cocap,
      'Content-Type': 'multipart/form-data'
    }
  })
  return data
}

export { getPrepaymentsService, postInvoiceFileService }
